import * as Type from "store/actionTypes/authType";
import { login as loginService } from "services";
import Swal from "sweetalert2";
import history from "utils/history";

export const login = (data) => async (dispatch) => {
  try {
    dispatch({
      type: Type.AUTH_REQUEST,
    });

    const res = await loginService(data);

    let { accessToken, user } = res;
    localStorage.setItem("accessToken", accessToken);
    Swal.fire("success", `Selamat datang ${user.username}`, "success");
    history.push("/a/dashboard");
  } catch (err) {
    Swal.fire("error", err.message, "error");
  }
};
export const logout = (data) => async (dispatch) => {
  try {
    localStorage.setItem("accessToken", "");
    Object.keys(localStorage)
      .filter((k) => k.startsWith("rt_"))
      .forEach((k) => localStorage.removeItem(k));
    history.push("/");
  } catch (err) {
    Swal.fire("error", err.message, "error");
  }
};
